import { css } from 'styled-components';

export const Strong = css`
  font-weight: 700;
`;
